module.exports = __webpack_public_path__ + "img/kaopu03.ba3f920b.jpg";